import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { IFilterComponent, SearchFilter } from "src/app/infrastructure/iFilter-component";
import { AuthService } from "src/app/services/auth.service";
import { BudgetService } from "src/app/services/budget/budget.service";
import { FilterRecordService } from "src/app/services/filter-record.service";
import { FilterService } from "src/app/services/filter.service";

@Component({
  selector: "app-budget-filter",
  templateUrl: "./budget-filter.component.html",
  styleUrls: ["./budget-filter.component.css"],
})
export class BudgetFilterComponent implements IFilterComponent, OnInit {
  form: FormGroup;
  @ViewChild("formElement", { static: false }) formElement: ElementRef;

  constructor(
    private formBuilder: FormBuilder,
    private filterService: FilterService,
    private authService: AuthService,
    private budgetService: BudgetService,
    private filterRecordService: FilterRecordService
  ) {
    const date = new Date();

    this.form = this.formBuilder.group({
      DateFrom: [date, Validators.required ],
      DateTo: [date, Validators.required],
      Patient: [null],
      ViewExpired: [false],
      ViewDisabled: [false],
    });
  }

  get f() {
    return this.form.controls;
  }

  async saveFilters() {
    this.filterRecordService.saveFilters(
      "StudyReportFilterComponent",
      this.form
    );
  }

  setFilters(): boolean {
    return this.filterRecordService.setFilters(
      "StudyReportFilterComponent",
      this.form
    );
  }

  getSearchFilters(): SearchFilter[] {
    return this.filterRecordService.convertToSearchFilters(
      this.form,
      []
    );
  }

  async search(): Promise<any> {
    if (this.form.invalid) {
      return;
    }

    const from = this.form.get("DateFrom").value;
    const to = this.form.get("DateTo").value;
    const viewExpired = this.form.get("ViewExpired").value;
    const viewDisabled = this.form.get("ViewDisabled").value;
    const patientId = this.form.get("Patient").value?  this.form.get("Patient").value.Id : null;

    const result = await this.budgetService.getByParameters(
      from,
      to,
      viewExpired,
      viewDisabled,
      patientId
    );

    console.log(result);
    return result;
  }

  ngOnInit(): void {

  }
}
